(function () {
  var root = document.querySelector('[data-dd-collection]');
  if (!root) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var moneyFmt;
  try { moneyFmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }); }
  catch (e) { moneyFmt = null; }
  function money(cents) {
    var v = moneyFmt ? moneyFmt.format(cents / 100) : '£' + (cents / 100).toFixed(2);
    return v.replace(/\.00($|\s)/, '$1');
  }

  /* ── Filters ── */
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-dd-card]'));
  var brandSel = root.querySelector('[data-dd-brand-filter]');
  var availSel = root.querySelector('[data-dd-avail-filter]');
  var empty = root.querySelector('[data-dd-empty]');
  var clearBtn = root.querySelector('[data-dd-clear]');

  function applyFilters() {
    var brand = brandSel ? brandSel.value : '';
    var avail = availSel ? availSel.value : '';
    var visible = 0;
    cards.forEach(function (c) {
      var ok = true;
      if (brand && c.getAttribute('data-brand') !== brand) ok = false;
      if (avail && c.getAttribute('data-available') !== avail) ok = false;
      c.classList.toggle('is-hidden', !ok);
      if (ok) visible++;
    });
    if (empty) empty.hidden = visible > 0;
  }

  if (brandSel) brandSel.addEventListener('change', applyFilters);
  if (availSel) availSel.addEventListener('change', applyFilters);
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (brandSel) brandSel.value = '';
      if (availSel) availSel.value = '';
      applyFilters();
    });
  }

  /* ── Festival week drawer + quick add (shared module: lineup-cart.js) ── */
  var grid = root.querySelector('[data-dd-grid]');
  if (!grid) return;
  if (!window.BWWLineupCart || !window.BWWLineupCart.init) {
    console.warn('BWW: lineup-cart.js not loaded; festival week drawer disabled.');
    return;
  }

  var emptyHint = root.getAttribute('data-cart-empty-hint') || 'Add tickets to start planning your week.';

  var productMeta = {};
  cards.forEach(function (c) {
    productMeta[c.getAttribute('data-id')] = {
      sort: c.getAttribute('data-date-sort') || '',
      label: c.getAttribute('data-date-label') || '',
      venue: c.getAttribute('data-venue') || ''
    };
  });

  var cart = window.BWWLineupCart.init({
    esc: esc,
    money: money,
    productMeta: productMeta,
    festivalStart: root.getAttribute('data-festival-start'),
    festivalEnd: root.getAttribute('data-festival-end'),
    emptyHTML:
      '<div class="lineup-cart__empty"><p>Your week is wide open.</p>' +
      '<p>' + esc(emptyHint) + '</p></div>',
    loadErrorHTML: '<p class="lineup-cart__empty">Couldn\u2019t load your cart.</p>'
  });
  if (!cart) return;

  var openDrawer = cart.open;
  var addVariant = cart.addVariant;

  var weekBtn = document.getElementById('dd-week-btn');
  if (weekBtn) weekBtn.addEventListener('click', openDrawer);

  function closePickers() {
    Array.prototype.forEach.call(document.querySelectorAll('.dd-card__picker'), function (p) { p.remove(); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-choose][aria-expanded="true"]'), function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  function openPicker(card, btn) {
    closePickers();
    var island = card.querySelector('[data-variants]');
    if (!island) return;
    var variants;
    try { variants = JSON.parse(island.textContent); } catch (e) { return; }

    var picker = document.createElement('div');
    picker.className = 'dd-card__picker';
    picker.innerHTML =
      '<div class="dd-card__picker-head">' +
        '<span class="dd-card__picker-title">Choose your date</span>' +
        '<button type="button" class="dd-card__picker-close" aria-label="Close">\u2715</button>' +
      '</div>' +
      '<ul class="dd-card__picker-list">' +
        variants.map(function (v) {
          return '<li><button type="button" class="dd-card__picker-opt" data-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
            '<span class="dd-card__picker-opt-name">' + esc(v.title) + '</span>' +
            '<span class="dd-card__picker-opt-price">' + (v.price === 0 ? 'Free' : money(v.price)) + '</span>' +
            '<span class="dd-card__picker-opt-add">' + (v.available ? 'Add' : 'Sold out') + '</span>' +
          '</button></li>';
        }).join('') +
      '</ul>' +
      '<div class="dd-card__picker-foot"><a href="' + esc(card.querySelector('.dd-card__title a').getAttribute('href')) + '">Full details \u2192</a></div>';

    card.appendChild(picker);
    btn.setAttribute('aria-expanded', 'true');
    picker.querySelector('.dd-card__picker-close').addEventListener('click', closePickers);

    picker.addEventListener('click', function (e) {
      var opt = e.target.closest('.dd-card__picker-opt');
      if (!opt || opt.disabled) return;
      opt.disabled = true;
      opt.querySelector('.dd-card__picker-opt-add').textContent = 'Adding\u2026';
      addVariant(parseInt(opt.getAttribute('data-variant'), 10))
        .then(function () { closePickers(); openDrawer(); })
        .catch(function () {
          opt.disabled = false;
          opt.querySelector('.dd-card__picker-opt-add').textContent = 'Try again';
        });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.dd-card__picker') && !e.target.closest('[data-choose]')) closePickers();
  });

  grid.addEventListener('click', function (e) {
    var chooseBtn = e.target.closest('[data-choose]');
    if (chooseBtn) {
      e.preventDefault();
      if (chooseBtn.getAttribute('aria-expanded') === 'true') closePickers();
      else openPicker(chooseBtn.closest('.dd-card'), chooseBtn);
      return;
    }

    var btn = e.target.closest('[data-add-variant]');
    if (!btn || btn.disabled || btn.classList.contains('is-busy')) return;
    e.preventDefault();
    btn.classList.add('is-busy');

    addVariant(parseInt(btn.getAttribute('data-add-variant'), 10))
      .then(function () {
        btn.classList.remove('is-busy');
        var label = btn.querySelector('.dd-card__add-label');
        if (label) label.textContent = 'Added \u2713';
        setTimeout(function () {
          if (label) label.textContent = 'Book now';
        }, 2400);
        openDrawer();
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        var label = btn.querySelector('.dd-card__add-label');
        if (label) label.textContent = 'Try again';
        setTimeout(function () {
          if (label) label.textContent = 'Book now';
        }, 2400);
      });
  });
})();
